export default __webpack_public_path__ + "static/fv-nr-4-876211e2fa379a294530c1485de40242.png";